<template>
  <div id="new-institution">
    <div class="content">
      <b-field label="Provincia">
          <b-select placeholder="Provincia *" v-model="provincia">
              <option
                  v-for="option in provincias"
                  :value="option.provincia_id"
                  :key="option.provincia_id">
                  {{ option.nombre }}
              </option>
          </b-select>
      </b-field>

      <b-field label="Nombre de la institucion *">
          <b-input v-model="name"></b-input>
        </b-field>
      <b-field label="Municipio">
           <b-input v-model="municipio"></b-input>
       </b-field>
       <b-field label="Tipo de institución">
           <b-select placeholder="Tipo de Institución " v-model="tipo">
               <option
                   v-for="option in tipos"
                   :value="option"
                   :key="option">
                   {{ option }}
               </option>
           </b-select>
       </b-field>
    </div>
  </div>
</template>
<script>
export default {
  /* eslint-disable */
  name: 'newInstitution',
  data: () => ({
    provincias: [
    {"provincia_id": "02", "nombre": "Albacete"}, {"provincia_id": "03", "nombre": "Alicante/Alacant"}, {"provincia_id": "04", "nombre": "Almería"}, {"provincia_id": "01", "nombre": "Araba/Álava"}, {"provincia_id": "33", "nombre": "Asturias"}, {"provincia_id": "05", "nombre": "Ávila"}, {"provincia_id": "06", "nombre": "Badajoz"}, {"provincia_id": "07", "nombre": "Balears, Illes"}, {"provincia_id": "08", "nombre": "Barcelona"}, {"provincia_id": "48", "nombre": "Bizkaia"},
     {"provincia_id": "09", "nombre": "Burgos"}, {"provincia_id": "10", "nombre": "Cáceres"}, {"provincia_id": "11", "nombre": "Cádiz"}, {"provincia_id": "39", "nombre": "Cantabria"}, {"provincia_id": "12", "nombre": "Castellón/Castelló"}, {"provincia_id": "13", "nombre": "Ciudad Real"}, {"provincia_id": "14", "nombre": "Córdoba"}, {"provincia_id": "15", "nombre": "Coruña, A"}, {"provincia_id": "16", "nombre": "Cuenca"}, {"provincia_id": "20", "nombre": "Gipuzkoa"}, {"provincia_id": "17", "nombre": "Girona"}, {"provincia_id": "18", "nombre": "Granada"}, {"provincia_id": "19", "nombre": "Guadalajara"}, {"provincia_id": "21", "nombre": "Huelva"}, {"provincia_id": "22", "nombre": "Huesca"}, {"provincia_id": "23", "nombre": "Jaén"}, {"provincia_id": "24", "nombre": "León"}, {"provincia_id": "25", "nombre": "Lleida"}, {"provincia_id": "27", "nombre": "Lugo"}, {"provincia_id": "28", "nombre": "Madrid"}, {"provincia_id": "29", "nombre": "Málaga"}, {"provincia_id": "30", "nombre": "Murcia"}, {"provincia_id": "31", "nombre": "Navarra"}, {"provincia_id": "32", "nombre": "Ourense"}, {"provincia_id": "34", "nombre": "Palencia"}, {"provincia_id": "35", "nombre": "Palmas, Las"}, {"provincia_id": "36", "nombre": "Pontevedra"}, {"provincia_id": "26", "nombre": "Rioja, La"}, {"provincia_id": "37", "nombre": "Salamanca"}, {"provincia_id": "38", "nombre": "Santa Cruz de Tenerife"}, {"provincia_id": "40", "nombre": "Segovia"}, {"provincia_id": "41", "nombre": "Sevilla"}, {"provincia_id": "42", "nombre": "Soria"}, {"provincia_id": "43", "nombre": "Tarragona"}, {"provincia_id": "44", "nombre": "Teruel"}, {"provincia_id": "45", "nombre": "Toledo"}, {"provincia_id": "46", "nombre": "Valencia/València"}, {"provincia_id": "47", "nombre": "Valladolid"}, {"provincia_id": "49", "nombre": "Zamora"}, {"provincia_id": "50", "nombre": "Zaragoza"}, {"provincia_id": "51", "nombre": "Ceuta"}, {"provincia_id": "52", "nombre": "Melilla"} ],
    name: '',
    provincia: '',
    municipio: '',
    tipo: '',
    tipos: ['Instituto', 'Universidad','Colegio', 'Academia', 'Otro']
  }),
  methods:{
    createInstitution () {
      this.$store.dispatch('user/addInstitution',
        {'name': this.name, 'provincia': this.provincia, 'city': this.municipio})
        .then(response => {
          this.$emit('done',response.data)
        }).catch(error => {
          console.log(error)
        })
    },
  }

}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/User/NewInstitution.vue